import React, { createContext, useContext, useState, useEffect } from 'react';
import { logOut } from "../modules/auth/Services";
import LoaderTemplate from "../components/LoaderTemplate";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({
      token: null,
      refresh_token: null,
      user: null,
      csrf_token: null
    });
    const [loading, setLoading] = useState(false);
    const [authLoading, setAuthLoading] = useState(true); // <-- important
  
    useEffect(() => {
      const storedAuth = localStorage.getItem('auth');
      if (storedAuth) {
        setAuth(JSON.parse(storedAuth));
      }
      setAuthLoading(false); // <-- after restoring from storage
    }, []);
  
    const login = (data) => {
      // data should be an object: { token, user }
      setAuth(data);
      if (data.token) {
        localStorage.setItem('auth', JSON.stringify(data));
      }
    };
    
    const logout = async () => {
      setLoading(true);
      return await logOut().then((response) => {
        if (response.status === 200) {
          setAuth({ token: null, refresh_token: null, user: null, csrf_token: null });
          localStorage.removeItem('auth');
        } else {
          console.error("Check Logout failed:", response);
        }
        setLoading(false);
        return response;
      }).catch((error) => {
        console.error("Logout error:", error);
        setLoading(false);
        return error;
      });
    };
  
    return (
      <AuthContext.Provider value={{ auth, login, logout, authLoading }}>
        {/* Start Generic Loader */}
        {loading && <LoaderTemplate />}
        {/* End Generic Loader */}
        {children}
      </AuthContext.Provider>
    );
};
  
export const useAuth = () => useContext(AuthContext);
  